




































































import { Vue, Component } from 'vue-property-decorator';
import router from '../router';
import { MedTransGoConstants } from '../util/constants';
import DataTable from '../components/DataTable.vue';
import AddPatientModal from './modal/AddPatientModal.vue';
import ViewPatientModal from './modal/ViewPatientModal.vue';
import UpdatePatientModal from './modal/UpdatePatientModal.vue';
import { ObjectFactory } from '../config/objectFactory';
import { CommonUtils } from '../util/commonUtils';
import { ToastEvent } from '../types/event';
import { EventBus } from '../main';
import { HealthcareProvider, Patient, Attorney, RxProvider } from '../types/entity';
import AddHealthCareProviderModal from './modal/AddHealthCareProviderModal.vue';
import UpdateHealthCareProviderModal from './modal/UpdateHealthCareProviderModal.vue';
import Menu from '../components/Menu.vue';
import AddRxProviderModal from './modal/AddRxProviderModal.vue';
import { MemberLocation, MemberProfile } from '@/types/response';
import { ApiRequest, QueryRecordsRequest, ServiceRequestModel } from '@/types/request';
import AddAttorneyModal from './modal/AddAttorneyModal.vue';
import ViewAttorneyModal from './modal/ViewAttorneyModal.vue';


// tslint:disable-next-line: no-var-requires
const PatientsTable = require('../datatable/PatientsTable.json');
// tslint:disable-next-line: no-var-requires
const AttorneysTable = require('../datatable/AttorneysTable.json');
// tslint:disable-next-line: no-var-requires
const HealthCareProviderTable = require('../datatable/HealthCareProviderTable.json');
// tslint:disable-next-line: no-var-requires
const RxProviderTable = require('../datatable/RxProviderTable.json');

@Component({
    methods: {
        goBack() {
            router.push({ name: MedTransGoConstants.VIEW_REQUESTS_PANEL_NAME });
        },
    },
    data() {
        const memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
        const notOrgAdmin = memberProfile.memberType === 'ORG_MANAGER' || memberProfile.memberType === 'ORG_MEMBER';
        const menuList = {
            header: 'Users',
            options: [{
                url: 'users?userType=healthcareprovider',
                activeConditions: {
                    userType: 'healthcareprovider',
                },
                label: 'Healthcare Facilities',
            },
            {
                url: 'users?userType=patient',
                activeConditions: {
                    userType: 'patient',
                },
                label: 'Patients',
            },
            {
                url: 'users?userType=rxprovider',
                activeConditions: {
                    userType: 'rxprovider',
                },
                label: 'Rx Providers',
            },
            ],
        };
        if (memberProfile.memberType === 'ORG_LIEN_CUSTOMER') {
            menuList.options.push({
                url: 'users?userType=attorney',
                activeConditions: {
                    userType: 'attorney',
                },
                label: 'Attorney(s)',
            });
        }
        if (memberProfile.memberType === 'ORG_LIEN_CUSTOMER') {
            menuList.options.splice(2, 1);
        }
        if (memberProfile.isRestrictedView && notOrgAdmin) {
            const patientOptionIndex = menuList.options.findIndex((option) => option.label === 'Patients');
            if (patientOptionIndex !== -1) {
                menuList.options.splice(patientOptionIndex, 1);
            }
        }
        return menuList;
    },
    components: {
        DataTable,
        AddPatientModal,
        ViewPatientModal,
        UpdatePatientModal,
        AddHealthCareProviderModal,
        UpdateHealthCareProviderModal,
        Menu,
        AddRxProviderModal,
        AddAttorneyModal,
        ViewAttorneyModal,
    },
    watch: {
        $route(to, from) {
            if (!to.path.endsWith(MedTransGoConstants.URL_ADD)) {
                const users = this as Users;
                users.getPatientList();
            }
            if (!to.path.endsWith(MedTransGoConstants.URL_UPDATE_HEALTHCARE_PROVIDER)) {
                const users = this as Users;
                users.getProviderList();
            }
            if (!to.path.endsWith(MedTransGoConstants.URL_UPDATE_RX_PROVIDER)) {
                const users = this as Users;
                users.getRxProviderList();
            }
            if (!to.path.endsWith(MedTransGoConstants.URL_ADD_ATTORNEY)) {
                const users = this as Users;
                users.getAttorneyList();
            }
        },
    },
})
export default class Users extends Vue {

    private patientDataSource = PatientsTable;
    private showViewPatient = false;
    private healthCareProviderDataSource = HealthCareProviderTable;
    private showAddHealthcareProviderForm = false;
    private rxProviderDataSource = RxProviderTable;
    private showAddRxProviderForm = false;
    private patientStart = 0;
    private providerStart = 0;
    private rxProviderStart = 0;
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private attorneyDataSource = AttorneysTable;
    private showAttorneyForm = false;
    private showUpdateAttorneyFormFlag = false;
    private selectedAttorney: Attorney = {};
    private showViewAttorneyModal = false;
    private attorneyStart = 0;

    public mounted() {
        this.getPatientList('', 0);
        this.getProviderList('', 0);
        this.getRxProviderList('', 0);
        this.getAttorneyList('', 0);
    }

    private async getPatientList(searchString?: string, start?: number) {
        const locations: string[] = [];
        if (this.memberProfile.memberType === 'ORG_MANAGER' && this.memberProfile.managedLocations) {
            this.memberProfile.managedLocations.forEach((location: MemberLocation) => {
                locations.push(location.name);
            });
        } else if (this.memberProfile.location && this.memberProfile.memberType !== 'ORG_ADMIN') {
            locations.push(this.memberProfile.location.name);
        } else if (this.memberProfile.managedLocations && this.memberProfile.memberType === 'ORG_MEMBER') {
            this.memberProfile.managedLocations.forEach((location: MemberLocation) => {
                locations.push(location.name);
            });
            if (this.memberProfile.location) {
                locations.push(this.memberProfile.location.name);
            }
        }
        if (typeof start !== 'undefined') {
            this.patientStart = start;
        } else if (this.patientStart > 0) {
            start = this.patientStart;
        }
        if (this.memberProfile.memberType === 'ORG_ADMIN' || ((this.memberProfile.isRestrictedView === undefined ||
            !this.memberProfile.isRestrictedView) && locations && locations.length > 0)) {
            const response = await ObjectFactory.getPatientService().
                getPatientList(this.$store.state.serverUrl, searchString, start, 1000, locations);
            if (response.success) {
                if (response.data) {
                    response.data.forEach((patient) => {
                        if (!patient.address || !patient.address.state) {
                            patient.address = {
                                fullAddress: '-',
                                state: '-',
                            };
                        }
                        if (!patient.phone) {
                            patient.phone = '-';
                        }
                    });
                }
                this.patientDataSource.data = response.data;
                if (response.totalCount) {
                    this.patientDataSource.totalCount = response.totalCount;
                }
            } else {
                CommonUtils.showError(response);
            }
        } else {
            const toastEvent: ToastEvent = {
                message: `You are not authorized to view this page`,
                title: 'Error',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        }
    }

    private showAddPatientForm() {
        this.$router.push({
            append: true,
            name: MedTransGoConstants.VIEW_ADD_PATIENT_NAME,
            query: { userType: 'patient' },
        });
    }

    private showViewPatientForm(patient: any) {
        this.$router.push({
            path: `users/patients/${patient.id}`,
            query: { userType: 'patient' },
            });
    }

    private showUpdatePatientForm(patient: any) {
        this.$router.push({
            path: `users/patients/update/${patient.id}`,
            query: { userType: 'patient' },
        });
    }

    private newServiceRequest(patient: Patient) {
        this.$router.push({ path: MedTransGoConstants.URL_REQUESTS, query: { patientId: patient.id } });
    }

    private async deletePatient(patient: any) {
        const response = await ObjectFactory.getPatientService().
            deletePatient(this.$store.state.serverUrl, patient.id);
        if (response.success) {
            this.getPatientList();
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode('MSG_DEACTIVATE_PATIENT'),
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
    }

    private async getProviderList(searchString?: string, start?: number) {
        if (typeof start !== 'undefined') {
            this.providerStart = start;
        } else if (this.providerStart > 0) {
            start = this.providerStart;
        }
        const locatonIds: string[] = [];
        if (this.memberProfile.memberType === 'ORG_MANAGER' && this.memberProfile.managedLocations) {
            this.memberProfile.managedLocations.forEach((location: MemberLocation) => {
                locatonIds.push(location.id);
            });
        } else if (this.memberProfile.location && this.memberProfile.memberType !== 'ORG_ADMIN') {
            locatonIds.push(this.memberProfile.location.id);
        } else if (this.memberProfile.managedLocations && this.memberProfile.memberType === 'ORG_MEMBER') {
            this.memberProfile.managedLocations.forEach((location: MemberLocation) => {
                locatonIds.push(location.id);
            });
            if (this.memberProfile.location) {
                locatonIds.push(this.memberProfile.location.id);
            }
        }
        const response = await ObjectFactory.getProviderService()
            .getHealthcareProviders(this.$store.state.serverUrl, searchString, start, undefined, locatonIds.length ?
                locatonIds : undefined);
        if (response.success) {
            this.healthCareProviderDataSource.data = response.data;
            if (response.totalCount) {
                this.healthCareProviderDataSource.totalCount = response.totalCount;
            }
        }
    }

    private showAddProviderForm() {
        this.showAddHealthcareProviderForm = true;
    }
    private showUpdateProviderForm(provider: HealthcareProvider) {
        this.$router.push({
            append: true,
            path: `${MedTransGoConstants.URL_UPDATE_HEALTHCARE_PROVIDER}/${provider.id}`,
            query: { userType: 'healthcareprovider' },
        });
    }
    private async deleteHealthCareFacility(provider: HealthcareProvider) {
        const iHttpService = ObjectFactory.getHttpService();
        const providerId = provider.id as any;
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_PROVIDERS}/${providerId}`,
        };
        const response = await iHttpService.delete<any>(apiRequest);
        if (response.success) {
            this.getProviderList();
            const toastEvent: ToastEvent = {
                message: `Healthcare Facility deleted succssfully`,
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        } else {
            CommonUtils.showError(response);
        }
    }
    private async getRxProviderList(searchString?: string, start?: number) {
        if (typeof start !== 'undefined') {
            this.rxProviderStart = start;
        } else if (this.rxProviderStart > 0) {
            start = this.rxProviderStart;
        }
        const response = await ObjectFactory.getRxProviderService()
            .getRxProviders(this.$store.state.serverUrl, searchString, start);
        if (response.success) {
            this.rxProviderDataSource.data = response.data;
            if (response.totalCount) {
                this.rxProviderDataSource.totalCount = response.totalCount;
            }
        }
    }

    private showAddRxProvider() {
        this.showAddRxProviderForm = true;
    }

    private showUpdateRxProviderForm(provider: RxProvider) {
        this.$router.push({
            append: true,
            path: `${MedTransGoConstants.URL_UPDATE_RX_PROVIDER}/${provider.id}`,
            query: { userType: 'rxprovider' },
        });
    }

    private async activateDeactivateRxProvider(provider: RxProvider) {
        const providerId = provider.id as any;
        const updateProviderRequest: RxProvider = {
            fullname: provider.fullname,
            email: provider.email,
            phone: provider.phone,
            status: (provider.status === 'ACTIVE' ? 'DEACTIVE' : 'ACTIVE'),
            address: provider.address,
            businessCloseTime: provider.businessCloseTime,
        };
        const response = await ObjectFactory.getRxProviderService().updateRxProvider(this.$store.state.serverUrl,
            providerId, updateProviderRequest);
        if (response.success) {
            this.getRxProviderList();
            const messageCode = updateProviderRequest.status === 'DEACTIVE' ? 'MSG_DEACTIVATE_RX_PROVIDER' : 'MSG_ACTIVATE_RX_PROVIDER';
            const toastEvent: ToastEvent = {
                message: CommonUtils.translateMessageCode(messageCode),
                title: 'Success',
                varient: 'success',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        }
    }

    private showAddAttorneyForm() {
        this.showAttorneyForm = true;
    }

    private async showUpdateAttorneyForm(attorney: any) {
        this.selectedAttorney = attorney;
        this.showUpdateAttorneyFormFlag = true;
    }

    private showViewAttorneyForm(attorney: any) {
        this.showViewAttorneyModal = true;
        this.selectedAttorney = attorney;
    }

    private async getAttorneyList(searchString?: string, start?: number) {
        try {
            if (typeof start !== 'undefined') {
                this.attorneyStart = start;
            } else if (this.attorneyStart > 0) {
                start = this.attorneyStart;
            }
            const iHttpService = ObjectFactory.getHttpService();
            const queryRecordsRequest: any = {
                conditions: [
                    {
                        op: 'eq',
                        fieldName: 'organizationId',
                        value: this.memberProfile &&
                               this.memberProfile.organization ?
                               this.memberProfile.organization.id : '',
                    },
                    {
                        op: 'eq',
                        fieldName: 'status',
                        value: 'ACTIVE',
                    },
                    {
                        op: 'eq',
                        fieldName: 'memberId',
                        value: this.memberProfile.memberId,
                    },
                ],
                start,
                order: {
                    createdOn: -1,
                },
            };
            if (searchString && searchString.length) {
                queryRecordsRequest.conditions.push({
                    fieldName: 'name',
                    op: 'regex',
                    value: `.*${searchString}*`,
                });
            }
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                data: queryRecordsRequest,
                url: `${MedTransGoConstants.HTTP_URL_ATTORNEY}/list`,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.post<any[]>(apiRequest);
            if (response.totalCount) {
                this.attorneyDataSource.totalCount = response.totalCount;
            }
            if (response.success && response.data) {
                this.attorneyDataSource.data = response.data;
            }
        } catch (error) {
            console.error('Error fetching attorney list:', error);
        }
    }

    private async deleteAttorney(attorney: any) {
        try {
            const iHttpService = ObjectFactory.getHttpService();
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_ATTORNEY}/${attorney.id}`,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.delete<any>(apiRequest);
            if (response.success && response.data) {
                this.getAttorneyList();
                this.attorneyDataSource.data = response.data;
                const toastEvent: ToastEvent = {
                    message: CommonUtils.translateMessageCode('MSG_DELETE_ATTORNEY'),
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                CommonUtils.showError(response);
            }
        } catch (error) {
            console.error('Error deleting attorney:', error);
        }
    }
}
